export default "__VITE_ASSET__CajVZXfq__"